const aaa = [
	{
		path: "staff",
		component: () => import("@/views/control/staff.vue"),
		meta:{title:'员工管理'},
	},{
		path: "UpdateRight",
		component: () => import("@/views/control/UpdateRight.vue"),
		meta:{title:'添加权限'},
	}
]
export default aaa;